import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

import { ref, reactive, onBeforeMount } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import TabsOperationLog from '@/components/TabsOperationLog/index.vue'
import VisitorProgramForm from '../components/VisitorProgramForm.vue'
import { visitorProgramDetail } from '@/api/yuntuSales/followUpManage'
import type { LbuVisitorProgramEditParams } from '@/typings/api/followUpManage'

const __default__ = { name: 'DcCosLbuVisitorProgramView' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const router = useRouter()
const route = useRoute()

const dataForm = reactive<LbuVisitorProgramEditParams>({})

onBeforeMount(() => {
  visitorProgramDetail(route.query.id as string).then((res) => {
    Object.assign(dataForm, res.data)
  })
})

const activeTabs = ref('info')
const handleTabsChange = (val: any) => {
  console.log(val)
}

const visitorProgramFormRef = ref()
const handleVisitComplete = (row = dataForm) => {
  router.push({ path: '/lbu/followUpRecord/visitingPlan', query: { planId: row.id } })
}
// const handleEdit = () => {
//   router.push({ path: '/lbu/visitorProgram/edit', query: { id: route.query.id as string } })
// }

return (_ctx: any,_cache: any) => {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_CosViewContent = _resolveComponent("CosViewContent")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_SellerButton = _resolveComponent("SellerButton")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_CosViewContent, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_tabs, {
                activeKey: activeTabs.value,
                "onUpdate:activeKey": _cache[1] || (_cache[1] = ($event: any) => ((activeTabs).value = $event)),
                onChange: handleTabsChange
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_tab_pane, {
                    key: "info",
                    tab: "计划详情"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(VisitorProgramForm, {
                        ref_key: "visitorProgramFormRef",
                        ref: visitorProgramFormRef,
                        title: "访客计划详情",
                        value: dataForm,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm) = $event)),
                        type: "view",
                        isEdit: false
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, {
                    key: "logs",
                    tab: "操作日志"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(TabsOperationLog, {
                        appId: "cos_lbu",
                        tableId: "LbuVisitorOperationLog",
                        resourceId: _unref(route).query.id as string
                      }, null, 8, ["resourceId"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["activeKey"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_cos_footer_button, { hideOk: true }, {
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createBlock(_component_SellerButton, {
            workCode: dataForm.createBy,
            controlType: "none",
            type: "primary",
            disabled: [3, 4].includes(dataForm.status as number),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (handleVisitComplete()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("完成计划")
            ]),
            _: 1
          }, 8, ["workCode", "disabled"])), [
            [_directive_permission, 'lbu_visitor_complete_btn']
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})